import isDevelopment from './isDevelopment';

/**
 * Changed to ternary and added local variable for duplicate value
 *
 *
 */
export default function publicBaseUrl() {
	let path = '/v1/public';
	let { hostname } = location;
	return isDevelopment() ? `http://${hostname}:5000${path}` : `https://api.${hostname}${path}`;
}
